<script>

	import './style.scss'

	export default {
		name: 'notification',
		props: [
			'show',
			'title',
			'message',
			'type'
		],
	}
</script>

<template>
	<div :class='{ notification: true, show: show, [type]: type }'>
		<header>
			{{ title }}
		</header>
		<p>{{ message }}</p>
	</div>
</template>



// WEBPACK FOOTER //
// src/components/Notification/Notification.vue